
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_10038_9205)","stroke":"#1F4053","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M7.97 16.11a3.36 3.36 0 01-4.19-.45l-.47-.47c-.44-.44-.44-1.15 0-1.59l1.99-1.98c.44-.43 1.14-.43 1.58 0 .44.44 1.15.44 1.59 0l3.17-3.17c.44-.44.44-1.15 0-1.59-.43-.44-.43-1.14 0-1.58l1.91-1.99c.44-.44 1.15-.44 1.59 0l.47.47c1.14 1.1 1.35 2.85.51 4.19a30.1 30.1 0 01-8.15 8.15v.01zM8.57.5C4.11.5.5 4.11.5 8.57M8.57 3.61A4.97 4.97 0 003.6 8.58"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_10038_9205"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h17.12v17.15H0z"}})])])])
          )
        }
      }
    